// v2
(function () {
  'use strict';

  const GIFT_WRAPPING_VARIANT_IDS = [50556073607333, 50556076458149];

  async function removeOrphanedGiftWrapping() {
    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    if (!cart?.items) return;

    const giftItems = cart.items.filter(
      (item) => GIFT_WRAPPING_VARIANT_IDS.includes(item.variant_id)
    );
    if (giftItems.length === 0) return;

    const cartVariantIds = cart.items
      .filter((item) => !GIFT_WRAPPING_VARIANT_IDS.includes(item.variant_id))
      .map((item) => String(item.variant_id));

    const orphanedGiftItems = giftItems.filter((item) => {
      const linkedTo = item.properties?.['_linked_to'];
      return linkedTo && !cartVariantIds.includes(linkedTo);
    });

    if (orphanedGiftItems.length === 0) return;

    for (const item of orphanedGiftItems) {
      await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    }

    window.location.reload();
  }

  function initCartRemoveListener() {
    // Ajax型（ドロワーカート）
    document.addEventListener('cart:change', async () => {
      if (isAddingToCart) return;
      await removeOrphanedGiftWrapping();
    });

    // リロード型（カートページ）
    document.addEventListener('click', async (event) => {
      const link = event.target.closest('a[href*="/cart/change"][href*="quantity=0"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (GIFT_WRAPPING_VARIANT_IDS.some(id => href.includes(String(id)))) return;

      event.preventDefault();

      const url = new URL(href, window.location.origin);
      const itemId = url.searchParams.get('id');

      await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemId, quantity: 0 }),
      });

      await removeOrphanedGiftWrapping();
      window.location.reload();
    });
  }

  let isAddingToCart = false;

  function initGiftWrapping() {
    document.addEventListener('click', async function (event) {
      const submitBtn = event.target.closest('button[type="submit"]');
      if (!submitBtn) return;
      if (!submitBtn.closest('buy-buttons')) return;

      console.log('★ボタン捕捉');

      const section = submitBtn.closest('.shopify-section, [id^="shopify-section"]') || document;
      const checkboxes = Array.from(
        section.querySelectorAll('.gift-wrapping-option__checkbox:checked')
      );
      console.log('★チェック済み数:', checkboxes.length);
      if (checkboxes.length === 0) return;

      const form = section.querySelector('form[action*="/cart/add"]');
      console.log('★form:', form);
      if (!form) return;

      const mainVariantId = form.querySelector('input[name="id"]')?.value;
      console.log('★mainVariantId:', mainVariantId);
      if (!mainVariantId) {
        console.error('[GiftWrapping] バリアントIDが取得できません');
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const submitButtons = Array.from(form.elements).filter(
        (el) => el.type === 'submit'
      );

      isAddingToCart = true;

      submitButtons.forEach((btn) => btn.setAttribute('aria-busy', 'true'));
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:loading:start', { bubbles: true })
      );

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const giftItems = checkboxes.map((cb) => ({
        id: Number(cb.dataset.variantId),
        quantity: 1,
        properties: { '_linked_to': String(mainVariantId) },
      }));

      const payload = {
        items: [
          { id: Number(mainVariantId), quantity: 1 },
          ...giftItems,
        ],
        sections: sectionsToBundle.join(','),
        sections_url: `${Shopify.routes.root}variants/${mainVariantId}`,
      };

      let response, responseJson;
      try {
        response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });
        responseJson = await response.json();
      } catch (err) {
        console.error('[GiftWrapping] fetch失敗:', err);
        submitButtons.forEach((btn) => btn.removeAttribute('aria-busy'));
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:end', { bubbles: true })
        );
        isAddingToCart = false;
        return;
      }

      console.log('★response.ok:', response.ok, 'status:', response.status);
      console.log('★responseJson:', responseJson);

      submitButtons.forEach((btn) => btn.removeAttribute('aria-busy'));
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:loading:end', { bubbles: true })
      );

      if (response.ok) {
        if (
          window.themeVariables.settings.cartType === 'page' ||
          window.themeVariables.settings.pageType === 'cart'
        ) {
          isAddingToCart = false;
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        cartContent['sections'] = responseJson['sections'];

        const items = responseJson.hasOwnProperty('items')
          ? responseJson['items']
          : [responseJson];

        form.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items, cart: cartContent, onSuccessDo: null },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: null, cart: cartContent },
          })
        );
      } else {
        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: responseJson['description'] || 'カートへの追加に失敗しました' },
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      setTimeout(() => { isAddingToCart = false; }, 500);

    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGiftWrapping();
      initCartRemoveListener();
    });
  } else {
    initGiftWrapping();
    initCartRemoveListener();
  }
})();
